<script setup>
import { reactive } from 'vue';

const props = defineProps({
  pollPreBrandColor: {
    type: Object,
    // required: true,
    default: reactive({
      color: 'rgba(255, 255, 255, 1)',
    }),
  },
  pollPreBrand: {
    type: String,
    // required: true,
    default: 'Sponsored by',
  },
  pollBrandLogos: {
    type: Array,
    // required: true,
    default: () => [
      {
        sponsorLogoImageSrc: '',
        // sponsorLogoImageWidth: '',
        // sponsorLogoImageHeight: '',
      },
    ],
  },
});
</script>

<template>
  <div class="poll-branding">
    <div class="poll-branding__pre-brand" :style="props.pollPreBrandColor">
      <span class="poll-branding__pre-brand-copy">{{ props.pollPreBrand }}</span>
    </div>

    <img class="poll-branding__logo" :src="props.pollBrandLogos[0].sponsorLogoImageSrc" />
  </div>
</template>
